// TES-1393 (2.1 S5) — "Om ditt vårdmöte" and "Förslag om extra vårdmöte" in
// the doctor's "Skicka besked", the pure parts.
//
// Pure on purpose (no React, no fetch) so `node --test` can run it.
import {
  MEETING_NOTICE_COPY,
  MEETING_NOTICE_CTAS,
  type DoctorNoticeRequest,
  type MeetingNoticeCta,
  type MeetingNoticeKind,
} from "@care-by-ella/contracts";

export interface MeetingMessageDraft {
  kind: MeetingNoticeKind;
  body: string;
  // "Om ditt vårdmöte"'s CTA; "" for none. Ignored on a proposal, which
  // always carries "Boka vårdmöte".
  cta: MeetingNoticeCta | "";
}

/**
 * The request a complete meeting message sends, or null while its text is
 * empty. No question and no follow-up: a meeting message has no answer
 * field (09C: "Det finns ingen svarsruta").
 */
export function meetingMessageRequest(
  d: MeetingMessageDraft,
): DoctorNoticeRequest | null {
  const body = d.body.trim();
  if (!body) return null;
  if (d.kind === "meeting_proposal") return { type: d.kind, body };
  return d.cta ? { type: d.kind, body, cta: d.cta } : { type: d.kind, body };
}

/** The CTA choices for "Om ditt vårdmöte", in 09C's order, plus none. */
export const MEETING_INFO_CTA_OPTIONS: Array<{
  value: MeetingNoticeCta | "";
  label: string;
}> = [
  { value: "", label: "Ingen knapp" },
  ...MEETING_NOTICE_CTAS.map((value) => ({
    value,
    label: MEETING_NOTICE_COPY.cta[value],
  })),
];

/** The button she gets with the message, or null for none. */
export function meetingMessageCtaLabel(d: MeetingMessageDraft): string | null {
  if (d.kind === "meeting_proposal")
    return MEETING_NOTICE_COPY.cta.book_meeting;
  return d.cta ? MEETING_NOTICE_COPY.cta[d.cta] : null;
}
